export default __webpack_public_path__ + "static/media/Armbands of the Refectory.28686bb3.jpg";